<template>
  <div class="markbox" v-show="loading" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="sun-loading">
        <span class="iconf"></span>
        <span class="iconf"></span>
        <span class="iconf"></span>
        <span class="iconf"></span>
    </div>
    <div class="text">{{text}}</div>
  </div>
</template>
 
<script>
export default {
    name: 'loading',
    data() {
        return {
            loading: false,
            text:this.$t('other.a393'),
        }
    },
    created() {
        var that = this;
        this.bus.$on('loading', function(data,desc=that.text) {
            that.loading = !!data;
            that.text=desc
            setTimeout(() => {
                that.loading=false
                
            },10000)
        })
    },


    mounted(){
        window.showLoading=()=> {
            this.bus.$emit('loading', true);
        }

        window.hideLoading=()=> {
            this.text=this.$t('other.a393')
            this.bus.$emit('loading', false);
        }
    }

}
</script>

<style lang="scss" scoped>
@import "../assets/scss/mixins";
.text{
    width: 200px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: -103px;
    right: 0;
    margin: auto;
    color: #fff;
    font-size: 12px;
    overflow: hidden;
    text-align: center;
}
.sun-loading {
	width: 50px;
	height: 50px;
	display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
	// animation: sunLoading 1s steps(12, end) infinite;
	// @include bg-image('../assets/img/loading.gif');
    margin:auto;
    position:absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right:0;
    animation: rotate 1.5s linear infinite;

    @keyframes rotate {
        to {
            transform: rotate(360deg);
        }
    }



    .iconf{
        display: inline-block;
        margin: 1px;
        padding: 1px;
        width: 20px;
        height: 20px;
        animation: scale 1.5s linear infinite;
    }

    @keyframes scale {
        50% {
            transform: scale(0.8);
        }
    }

    .iconf:nth-child(1){
        background-color: #778beb;
        border-radius: 50% 50% 0 50%;
    }
    .iconf:nth-child(2){
        background-color: #f8a5c2;
        border-radius: 50% 50% 50% 0;
        animation-delay: 0.5s;
    }
    .iconf:nth-child(3){
        background-color: #f5cd79;
        border-radius: 50% 0 50% 50%;
        animation-delay: 1s;
    }
    .iconf:nth-child(4){
        background-color: #e77f67;
        border-radius:  0 50% 50% 50%;
        animation-delay: 1.5s;
    }
}






.markbox{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1003;
}


</style>